import {IIterationStep, IProcessFlowVariableMap} from "~/interfaces/processFlowInterfaces"
import { RelationType } from '~/models/relationType'
import IRepo from '~/interfaces/repo'
import Repo from '~/state/modules/repo'
import { IClientIdable } from '~/interfaces/propertyInterfaces'
import ProcessFlowBuilderModel from "~/models/tracked/processFlowBuilderModel";
import ProcessFlowMappedVariable from "~/models/processFlows/steps/processFlowMappedVariable";
import {Hash} from "~/interfaces/hashInterfaces";
import Guid from '~/helpers/guid'
import IterationStepMappedVariable from '~/models/processFlows/steps/iterationStepMappedVariable'

export class IterationStepVariableMap extends ProcessFlowBuilderModel implements IProcessFlowVariableMap {
  parent: IIterationStep;

  variable_reference: IterationStepMappedVariable

  constructor(parent: IIterationStep) {
    super();
    this.parent = parent;
    this._nameInParent = 'variable_map'
    this._isCollectionRoot = false
    this.defineClientId();
  }

  // ******************** RELATIONS AND REPOS ******************** //
  static repo: IRepo<IterationStepVariableMap> = new Repo<IterationStepVariableMap>('runIterationVariableMaps', IterationStepVariableMap, {});
  repo: IRepo<this>;

  addToRepo(): void {
    IterationStepVariableMap.repo.add(this)
  }

  get EMBEDDED_MODELS(): { [key: string]: { type: any, relationType: RelationType } } {
    return {
      "variable_reference": { type: ProcessFlowMappedVariable, relationType: RelationType.singleObject },
    }
  }

  createEmbeddedObject = {
    variable_reference: (parent, json: Hash & Partial<IClientIdable>): IterationStepMappedVariable => {
      return IterationStepMappedVariable.repo.findOrCreateWith(json.client_id, 'variable_reference')
        .loadFromJson(json, parent)
    },
  }


  createVariableReference(): ProcessFlowMappedVariable {
    const varRef = this.createEmbeddedObject.variable_reference(this, { client_id: Guid.create() })
    varRef.attachToParent(this)
    return varRef
  }

  get variableReference(): ProcessFlowMappedVariable {
    return this.variable_reference || this.createVariableReference()
  }

  get collectionKey() {
    return this._nameInParent
  }

  get rootName(): string {
    return this._nameInParent;
  }

  // ******************** RELATIONS AND REPOS END ******************** //
}